/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {EAdasProgramSensorBomCheckboxTypes} from "./types";
import CircleIcon from "@mui/icons-material/Circle";
import SquareIcon from "@mui/icons-material/Square";
import React from "react";
import {BsDiamondFill, BsTriangleFill} from "react-icons/bs";

const getSensorIcon = (sensorType: string, size: string = '24px') => {
  const upperCaseSensorType = sensorType.toUpperCase()
  let logo = null
  switch (upperCaseSensorType) {
    case EAdasProgramSensorBomCheckboxTypes.CAMERAS.toUpperCase():
      logo = <CircleIcon sx={{fontSize: size}} htmlColor={'#6f088a'}/>
      break;
    case EAdasProgramSensorBomCheckboxTypes.RADARS.toUpperCase():
      logo = <SquareIcon sx={{fontSize: size}} htmlColor={'#f5b11d'}/>
      break;
    case EAdasProgramSensorBomCheckboxTypes.LIDARS.toUpperCase():
      // logo = <BsTriangleFill style={{fontSize: size, color: 'yellow', margin: 4}}/>
      logo = <BsTriangleFill style={{fontSize: size, color: 'yellow', margin: 0}}/>
      break;
    case EAdasProgramSensorBomCheckboxTypes.ULTRASONIC.toUpperCase():
      logo = <BsDiamondFill style={{fontSize: size, color: '#F08484', margin: 0}}/>
      break;
  }
  return logo;
}

export {
  getSensorIcon
}